import { render, staticRenderFns } from "./activity_tp_edit.vue?vue&type=template&id=0511572b&scoped=true"
import script from "./activity_tp_edit.vue?vue&type=script&lang=js"
export * from "./activity_tp_edit.vue?vue&type=script&lang=js"
import style0 from "./activity_tp_edit.vue?vue&type=style&index=0&id=0511572b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0511572b",
  null
  
)

export default component.exports